import { Pie } from '@ant-design/charts';
import PropType from 'prop-types';
import { CONFIG_PIE } from '../util/constant';

const PieChart = ({ data }) => {
  return <Pie {...CONFIG_PIE} data={data} />;
};

export default PieChart;

PieChart.propTypes = {
  data: PropType.arrayOf(PropType.shape({})).isRequired
};
